import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ensures each page navigation starts scrolled to the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return null;
}
